import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { User } from '../models';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    1
  email: string = '';
  baseUrl = environment.bpmsBaseUrl;
  constructor(private http: HttpClient, private router: Router) {
  }
  public setCustomerPasscode(email: string) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type','application/json');
    headers = headers.set('email',email);
    //const params = new HttpParams().set('customer_email', email);
    const url = this.baseUrl + `customer/setcustomerpasscode`;
    return this.http.get(url, { 'headers':headers });
  }

  public loginUser(data) {
    //const params = new HttpParams().set('customer_email',email).set('passcode',otp);
    const url = this.baseUrl + `auth/login`;
    return this.http.post(url, data);
  }
  public getEmailFromToken(token) {
    const params = new HttpParams().set('accessToken', token);
    const url = this.baseUrl + `auth/GetEmailFromToken`;
    return this.http.post(url, token);
  }

  public getSaltAndCapcha() {
    const url = this.baseUrl + `auth/getsaltandcaptcha`;
    return this.http.get(url);
  }

  public getRefreshCaptcha(sessionId) {
    let params = new HttpParams();
    params = params.set('sessionId', sessionId);
    const url = this.baseUrl + `auth/reloadcaptcha`;
    return this.http.get(url, { params });
  }

  public login(): void {
    localStorage.setItem('token', 'token');
  }

  public sign(): void {
    localStorage.setItem('token', 'token');
  }

  public signOut(): void {
    this.router.navigate(['/login']);
    localStorage.removeItem('token');
    localStorage.clear();
  }


  public getUser(): Observable<User> {
    return of({
      name: 'John',
      lastName: 'Smith'
    });
  }
}
